import { useEffect } from 'react';

import type { MegaWorldId } from '../generated/MegaWorldId';
import { useEmbark } from '../platform/store';
import styles from './embark.module.css';

const DESCRIPTIONS: Record<MegaWorldId, string> = {
  US: 'Western hemisphere',
  EU: 'European continent',
  Asia: 'Eastern hemisphere',
};

const DISPLAY_NAMES: Record<MegaWorldId, string> = {
  US: 'United States',
  EU: 'Europe',
  Asia: 'Asia',
};

export function MegaWorldPicker({
  onSelect,
}: {
  onSelect: (id: MegaWorldId) => void;
}): JSX.Element {
  const megaWorlds = useEmbark((s) => s.megaWorlds);
  const fetchMegaWorlds = useEmbark((s) => s.fetchMegaWorlds);

  useEffect(() => {
    if (megaWorlds.length === 0) void fetchMegaWorlds();
  }, [megaWorlds.length, fetchMegaWorlds]);

  return (
    <div className={styles.pickerBody}>
      <div className={styles.pickerTitle}>Choose a Mega-World</div>
      <div className={styles.pickerGrid}>
        {(['US', 'EU', 'Asia'] as MegaWorldId[]).map((id) => (
          <div
            key={id}
            className={styles.pickerCard}
            onClick={() => onSelect(id)}
          >
            <div className={styles.pickerCardId}>
              {DISPLAY_NAMES[id]}
            </div>
            <div className={styles.pickerCardDesc}>
              {DESCRIPTIONS[id]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
